import styles from './index.module.scss';
import { checkIfPeriodOverlap } from '../../../../utils/dateHelper';
import { getLocalDate } from '../../../../services/timeService/index';
import customConfirmAlert from '../../../../components/ConfirmAlert';
import { head } from 'lodash';
import {
  rtmConfirmDialogOptions,
  IRtmConfirmDialogOption,
  eventType,
} from '../events-fields-options';
import { dateTimeFormat } from '../../../../services/timeService/types';
import { IAdministrationInfo } from '../../../../services/patientProfileService/episodeofCareInfo/types';
import { IClinicalEvent } from '../types';
import classNames from 'classnames';

function rtmConfirmAlert({
  eventTime,
  type,
  isNewItem,
  data,
  episodeofCareDate,
  toggleBillingPeriod,
}: {
  eventTime: string;
  type: string;
  data: IClinicalEvent[];
  episodeofCareDate: IAdministrationInfo;
  toggleBillingPeriod: (data: {
    data: { startDate?: string; endDate?: string };
    inValidateQuery?: boolean;
  }) => void;
  isNewItem?: boolean;
}) {
  if (
    !isNewItem ||
    episodeofCareDate?.currentPayPeriod?.uuid ||
    checkIfPeriodOverlap(episodeofCareDate?.billingPeriods, eventTime) ||
    (type === eventType.educationOrTraining &&
      data?.some(
        (event) =>
          head(event?.versions)?.eventName === eventType.educationOrTraining
      ))
  ) {
    return;
  }

  const { title, body, subText } =
    rtmConfirmDialogOptions[type] ?? ({} as IRtmConfirmDialogOption);
  customConfirmAlert({
    title,
    body,
    subText,
    label: 'Activate RTM',
    cancelText: 'Continue without activation',
    onClick: () => {
      toggleBillingPeriod({
        data: {
          startDate: getLocalDate(eventTime).format(dateTimeFormat.SERVER_DATE_FORMAT),
        },
        inValidateQuery: true,
      });
    },
    classes: {
      overlay: classNames(styles.overlay, 'overlay-col-confirm-alert'),
      primary: styles.alertBtn,
      secondary: styles.alertBtn,
      subText: styles.subTextWithoutPadding,
    },
  });
}

export default rtmConfirmAlert;
